exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, "@media(min-width: 640px){.modal-module-Width{min-width:600px;max-width:600px}}", "",{"version":3,"sources":["/opt/buildhome/repo/src/components/Modal/modal.module.scss"],"names":[],"mappings":"AAGA,yBACI,oBACI,eAAA,CACA,eAAA,CAAA","file":"modal.module.scss","sourcesContent":["@import \"../../assets/scss/uikit/variables.scss\";\n@import \"../../assets/scss/global/variables-custom\";\n\n@media (min-width: $breakpoint-small) {\n    .Width {\n        min-width: 600px;\n        max-width: 600px;\n    }\n}\n"]}]);

// Exports
exports.locals = {
	"Width": "modal-module-Width"
};